<template>
	<div>
       <div id="myfroms"></div>
	</div>
</template>
<script>
	export default {
		created() {
			this.$http.post(urls.urltest + "/alipay/zfbpay.json", {
					token: localStorage.getItem('token'),
					ordernumber:localStorage.getItem('orderNumber'),
				}).then(function(res) {
					setTimeout(function() {
					  document.getElementById('myfroms').innerHTML = res.bodyText
	    			  document.forms[0].submit()
				})
			})
		}
	}
</script>


// WEBPACK FOOTER //
// pay.vue?67bd7501